import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../api";
import { useCompany } from "../Company/CompanyContext";
import { toast } from "react-toastify";
import { FaTrash, FaPlus, FaGripVertical } from "react-icons/fa";

export default function PrestationTypesTab({ raw }) {
  const { t } = useTranslation();
  const { reload } = useCompany();
  const [types, setTypes] = useState(() => {
    try { return JSON.parse(raw.prestation_types || "[]"); }
    catch { return ["Déménagement", "Garde-meuble", "Montage/Démontage", "Transport"]; }
  });
  const [newType, setNewType] = useState("");
  const [saving, setSaving]   = useState(false);

  const add = () => {
    const v = newType.trim();
    if (!v || types.includes(v)) return;
    setTypes((t) => [...t, v]);
    setNewType("");
  };

  const remove = (i) => setTypes((t) => t.filter((_, idx) => idx !== i));

  const moveUp   = (i) => { if (i === 0) return; const t = [...types]; [t[i-1], t[i]] = [t[i], t[i-1]]; setTypes(t); };
  const moveDown = (i) => { if (i === types.length - 1) return; const t = [...types]; [t[i], t[i+1]] = [t[i+1], t[i]]; setTypes(t); };

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings", { prestation_types: JSON.stringify(types) });
      await reload();
      toast.success(t("settings.prestations.saved"));
    } catch {
      toast.error(t("settings.common.saveError"));
    } finally { setSaving(false); }
  };

  return (
    <div className="space-y-6 max-w-lg">
      <p className="text-sm text-base-content/60">
        {t("settings.prestations.intro")}
      </p>

      <ul className="space-y-2">
        {types.map((pt, i) => (
          <li key={i} className="flex items-center gap-2 bg-base-200 rounded-lg px-3 py-2">
            <FaGripVertical className="text-base-content/30 cursor-grab" />
            <span className="flex-1 text-sm font-medium">{pt}</span>
            <button onClick={() => moveUp(i)}   className="btn btn-ghost btn-xs px-1" title={t("settings.prestations.up")}>↑</button>
            <button onClick={() => moveDown(i)} className="btn btn-ghost btn-xs px-1" title={t("settings.prestations.down")}>↓</button>
            <button onClick={() => remove(i)}   className="btn btn-ghost btn-xs text-error px-1" title={t("settings.prestations.remove")}>
              <FaTrash />
            </button>
          </li>
        ))}
      </ul>

      <div className="flex gap-2">
        <input
          type="text"
          value={newType}
          onChange={(e) => setNewType(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && add()}
          placeholder={t("settings.prestations.addPlaceholder")}
          className="input input-bordered input-sm flex-1 bg-base-200 border-base-300 focus:border-primary focus:outline-none"
        />
        <button onClick={add} className="btn btn-sm btn-ghost border border-base-300">
          <FaPlus /> {t("settings.prestations.add")}
        </button>
      </div>

      <div className="flex justify-end">
        <button onClick={save} disabled={saving} className="btn btn-primary">
          {saving ? t("settings.prestations.saving") : t("settings.prestations.save")}
        </button>
      </div>
    </div>
  );
}
